import { render, staticRenderFns } from "./VueToast.vue?vue&type=template&id=6f5e5520&"
import script from "./VueToast.vue?vue&type=script&lang=js&"
export * from "./VueToast.vue?vue&type=script&lang=js&"
import style0 from "./VueToast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports